import Slide from '../components/Slide';
import { enphaseCustomer } from '../data/pages';

export default function EnphaseCustomer() {
  const { dataKey, heading, options } = enphaseCustomer;
  return <Slide dataKey={dataKey} heading={heading} options={options} />;
}
